import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiResponse, BaseModalComponent} from "common-shared";
import {ContactModel, ContactService} from "../contact.service";
import {SpecLinesEditComponent} from "../../spec/spec-lines-edit/spec-lines-edit.component";
import {Subject} from "rxjs";

@Component({
  selector: 'app-contact-edit-modal',
  templateUrl: './contact-edit-modal.component.html',
  styles: []
})
export class ContactEditModalComponent extends BaseModalComponent implements OnInit {
  entityId: string;
  contact = new ContactModel();
  response: ApiResponse<any>;
  @ViewChild(SpecLinesEditComponent, {static: false}) specLinesEditComponent: SpecLinesEditComponent;
  wasValidated$ = new Subject<boolean>();

  constructor(private contactService: ContactService) {
    super();
  }

  ngOnInit(): void {
    if (this.entityId) {
      this.contactService.loadOne(this.entityId).subscribe(value => this.contact = value);
    }
  }

  add() {
    this.wasValidated$.next(true);
    if (this.contact.isValid()) {
      this.contactService.addNew(this.contact).subscribe({
        next: value => {
          this.entityId = value.Id;
          this.close()
        }, error: value1 => {
          this.response = value1.error;
        }
      });
    }
  }

  save(withClose: boolean = true) {
    this.wasValidated$.next(true);
    if (this.contact.isValid()) {
      this.contactService.save(this.contact).subscribe({
        next: value => {
          this.entityId = value.Id;
          if (withClose) {
            this.close();
          }
        }, error: value1 => {
          this.response = value1.error;
        }
      });
    }
  }

  delete() {
    this.contactService.remove(this.contact).subscribe({
      next: value => {
        this.entityId = null;
        this.close();
      }, error: value1 => {
        this.response = value1.error;
      }
    });
  }
}
